(() => {
  const initialize = (root) => {
    const article = root.querySelector('[data-approach-page]');
    if (!article || article.dataset.approachReady) return;
    article.dataset.approachReady = 'true';
    article.addEventListener('click', (event) => {
      const link = event.target.closest('[data-approach-choice]');
      if (!link || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      const id = link.hash.slice(1);
      const heading = article.querySelector(`#${CSS.escape(id)}`);
      if (!heading) return;
      requestAnimationFrame(() => heading.focus({ preventScroll: true }));
    });
  };
  initialize(document);
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
})();
